export default "__VITE_ASSET__D8zxVXY5__"